import Config from '@config';
import { initializeCommercialMeteringPointApi } from '@gasbi/shared/common/features/commercialMeteringPoint';
import { useSelector } from 'react-redux';

import { cachedItemByIdSelector } from '@/features/utils';
import axiosBaseQuery from '@/utils/axiosBaseQuery';

const commercialMeteringPoint = initializeCommercialMeteringPointApi({
  baseUrl: Config.VITE_API_URL,
  baseQuery: axiosBaseQuery,
});

export const {
  commercialMeteringPointsApi,
  useGetCommercialMeteringPointsQuery,
  useLazyGetCommercialMeteringPointsQuery,
  useGetCommercialMeteringPointByIdQuery,
  useCreateCommercialMeteringPointMutation,
  useUpdateCommercialMeteringPointMutation,
  useDeleteCommercialMeteringPointMutation,
  useUpdateCommercialMeteringPointConnectedPowerMutation,
  useGetCommercialMeteringPointReferenceBooksQuery,
  useGetCommercialMeteringPointDocumentsAndActsQuery,
  useGetCommercialMeteringPointDocumentsAndActsGridifyQuery,
  useLazyGetCommercialMeteringPointDocumentsAndActsGridifyQuery,
  useGetCommercialMeteringPointsInfiniteQuery,
  useGetCommercialMeteringPointByIdStatusHistoryInfiniteQuery,
  useGetCommercialMeteringPointDocumentsAndActsGridifyInfiniteQuery,
  useGetCommercialMeteringPointDeviceGridifyInfiniteQuery,
} = commercialMeteringPoint;

const getCachedCommercialMeteringPointByIdSelector = cachedItemByIdSelector(
  'commercialMeteringPointsApi',
  'getCommercialMeteringPointsI',
);

export const useGetCachedCommercialMeteringPointByIdSelector = id =>
  useSelector(getCachedCommercialMeteringPointByIdSelector(id));

export const getCachedCommercialMeteringPointDocumentsAndActsSelector =
  commercialMeteringPointsApi.endpoints[
    'getCommercialMeteringPointDocumentsAndActsGridifyI'
  ].select(undefined);
